import React, { useCallback } from 'react';

import { Tooltip, Typography } from '@mui/material';
import PendingChangeWrapperCDS from '@sharedCR/coreDesignSystem/PendingChangeWrapperCDS';
import _ from 'lodash';
import PropTypes from 'prop-types';

import { getHeaderPendingChangeKind } from 'utils/pendingChangeKind';

import HeaderItemValue from '../../HeaderItemValue';
import { AUS_NA_FALLBACK_TEXT } from '../../HeaderItemValue/HeaderItemValue.constants';
import { itemValueStyles } from '../HeaderViewList/HeaderViewList.styles';

const HeaderFieldValue = ({
  normalizedName,
  formattedValue,
  value = null,
  hasPendingChange = false,
  changeKind = null,
}) => {
  const pendingChangeKind = getHeaderPendingChangeKind(hasPendingChange, changeKind);

  const renderText = useCallback(
    text => {
      const safeText = _.isString(text) || _.isNumber(text) ? text : '';

      return (
        <PendingChangeWrapperCDS isSmall changeKind={pendingChangeKind}>
          <Typography sx={itemValueStyles(safeText === AUS_NA_FALLBACK_TEXT)} variant="regular14">
            <Tooltip title={safeText}>
              <span>{safeText}</span>
            </Tooltip>
          </Typography>
        </PendingChangeWrapperCDS>
      );
    },
    [pendingChangeKind],
  );

  return (
    <HeaderItemValue
      formattedValue={formattedValue}
      normalizedName={normalizedName}
      rawValue={value}
      renderText={renderText}
    />
  );
};

HeaderFieldValue.propTypes = {
  normalizedName: PropTypes.string.isRequired,
  changeKind: PropTypes.string,
  formattedValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
  hasPendingChange: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
};

export default HeaderFieldValue;
